import produce from "immer";

import { ModelState } from "../../../interfaces/modelState";
import { AddressMutationModel } from "./AddressMutation.interfaces";

interface State {
  data: Partial<AddressMutationModel>;
  loading: boolean;
  modelState: ModelState | null;
}

export const initialState: State = {
  data: {
    postcode: undefined,
    houseNumber: undefined,
    houseNumberAddition: undefined,
    street: undefined,
    city: undefined,
    hasAdditionalAddressDetails: false,
    location: undefined,
    startDate: undefined,
    contactIds: [],
  },
  loading: false,
  modelState: null,
};

type Action =
  | { type: "UPDATE_ADDRESSMUTATION_DATA"; payload: Partial<AddressMutationModel> }
  | { type: "UPDATE_ADDRESSMUTATION_ERROR"; payload: ModelState }
  | { type: "UPDATE_ADDRESSMUTATION_FETCH_START" }
  | { type: "UPDATE_ADDRESSMUTATION_FETCH_ERROR"; payload: ModelState };

export const addressMutationReducer = (state: State, action: Action): State => {
  switch (action.type) {
    case "UPDATE_ADDRESSMUTATION_DATA":
      return produce(state, (draft) => {
        draft.data = { ...draft.data, ...action.payload };
      });
    case "UPDATE_ADDRESSMUTATION_ERROR":
      return produce(state, (draft) => {
        draft.modelState = action.payload;
      });
    case "UPDATE_ADDRESSMUTATION_FETCH_START":
      return produce(state, (draft) => {
        draft.loading = true;
      });
    case "UPDATE_ADDRESSMUTATION_FETCH_ERROR":
      return produce(state, (draft) => {
        draft.loading = false;
        draft.modelState = action.payload;
      });
  }
};
